import validate from "/usr/src/app/content/n3-spas-c28dc112-0796-498f-a61e-066a9c3eddf6/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-c28dc112-0796-498f-a61e-066a9c3eddf6/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}